export default {
    getRandomId() {
      return new Date().getTime()
    }
  }